import React from 'react';
import { useStore } from 'effector-react';
import type { HSIconImage, HSIconSeqFrame, HSIconVideo } from '@types';
import Slider from '@components/Slider';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { MainPlayer } from '@stores/krpPlayerStores';

interface Props {
  title: string;
  propKey: 'rx' | 'ry' | 'rz';
}

const MIN = -180;
const MAX = 180;
const STEP = 0.1;

const fixValue = (val: number) => (val > 180 ? val - 360 : val);

type Icon = HSIconImage | HSIconSeqFrame | HSIconVideo;
const valToString = (val: number) => `${val}°`;

function TabRotate({ title, propKey }: Props) {
  const { hotspot, isBatch, batchHotspots } = useStore($editingHotspot)!;
  const icon = hotspot.icon as Icon;

  const handleRotateChange = (val: number) => {
    $editingHotspotApi.update((draft) => {
      (draft.icon as Icon)[propKey] = val;
    });
    if (!isBatch) {
      MainPlayer.get()?.updateHotspot({ id: hotspot.id, [propKey]: val });
    } else {
      (batchHotspots ?? []).forEach((item) => {
        MainPlayer.get()?.updateHotspot({ id: item.id, [propKey]: val });
      });
    }
  };

  return (
    <Slider
      value={fixValue(icon[propKey])}
      min={MIN}
      max={MAX}
      valToString={valToString}
      onChange={handleRotateChange}
    >
      <Slider.Header title={title} />
      <Slider.Bar step={STEP} />
      <Slider.Control step={STEP} />
    </Slider>
  );
}

export default TabRotate;
